export const getFields = (data: any) => {
  return [
    { label: "Vehicle", value: data?.vehicle?.name },
    { label: "Coverage Type", value: data?.coverage_type },
    { label: "Warranty Name", value: data?.name },
    { label: "Manufacturer", value: data?.manufacturer },
    { label: "Warranty Vendor", value: data?.vendor?.name },
    { label: "Contract ID", value: data?.contract_id },
    { label: "Vendor Link", value: data?.vendor_link },
    { label: "Start Date", value: data?.start_date },
    { label: "Coverage Duration", value: data?.coverage_distance },
    { label: "End Date", value: data?.end_date },
    { label: "Start Meter", value: data?.start_meter },
    { label: "Coverage Distance", value: data?.coverage_distance },
    { label: "End Meter", value: data?.end_meter },
  ];
};
